import React from 'react'
import { ScrollView } from 'react-native'

import { Box } from 'widgets/Box'

import { FilterOptionsContainerStyles } from '../styled'
import { ModalContentProps } from '../types'

export const FilterOptionsModalContent = ({ children, testID }: ModalContentProps) => {
  return (
    <FilterOptionsContainerStyles testID={testID}>
      <ScrollView>
        <Box>{children}</Box>
      </ScrollView>
    </FilterOptionsContainerStyles>
  )
}
